// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"c7b16ba6","90":"0a2f753a","114":"e6ce0982","196":"9b93fdd4","237":"ffa2e815","246":"56d09963","378":"551fefa9","422":"474b0db8","427":"0233c005","661":"47b47a6e","854":"444a3ed3","901":"f9e62a9b","951":"04e74af0"}[chunkId] + ".chunk.js";
};